<template>
  <el-form-item :label="label" prop="img_code_answer" :rules="[{ required: true, message: '请输入图形验证码', trigger: 'blur' }]">
    <div style="display: flex; width: 100%; gap: 10px">
      <el-input class="input_text right" v-model="value" type="text" placeholder="请输入图形验证码" />
      <img :src="img" style="width: 120px; height: 40px; cursor: pointer" @click="getImageCode()" />
    </div>
  </el-form-item>
</template>
<script setup lang="ts">
import { computed, defineEmits, defineProps, withDefaults } from "vue";
interface Props {
  modelValue: string;
  img: string;
  getImageCode: () => void;
  isLabel?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  img: "",
  getImageCode: () => null,
  isLabel: false,
});
const emit = defineEmits(["update:modelValue"]);
const label = computed(() => (props.isLabel ? "图形验证码" : ""));
props.getImageCode();
const value = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit("update:modelValue", val);
  },
});
</script>
